import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addIssueType: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.add-issue-type',
		defaultMessage: 'Add request type',
		description: 'Button in navigation sidebar. Opens a modal dialog',
	},
	projectSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.project-settings',
		defaultMessage: 'Project settings',
		description: 'Service project Settings Title',
	},
	details: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.details',
		defaultMessage: 'Details',
		description: 'title for Details navigation item',
	},
	itsmFeatures: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.itsm-features',
		defaultMessage: 'Features',
		description: 'title for ITSM features navigation item',
	},
	customerPermissions: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-permissions',
		defaultMessage: 'Customer permissions',
		description: 'title for Customer permissions navigation item',
	},
	customerNotifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-notifications',
		defaultMessage: 'Customer notifications',
		description: 'title for Customer notifications navigation item',
	},
	notificationEmail: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.notification-email',
		defaultMessage: 'Notification email',
		description: 'title for notification emails navigation item for next gen notifications',
	},
	internalNotifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.internal-notifications',
		defaultMessage: 'Internal notifications',
		description: 'title for internal notifications navigation item for next gen notifications',
	},
	widget: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.widget',
		defaultMessage: 'Widget',
		description: 'title for the Widget settings navigation item',
	},
	portalSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.portal-settings',
		defaultMessage: 'Portal',
		description: 'title for Portal settings navigation item',
	},
	email: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.email',
		defaultMessage: 'Email',
		description: 'title for Email navigation item',
	},
	access: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.access',
		defaultMessage: 'Internal access',
		description: 'title for project internal-access navigation item',
	},
	notifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.notifications',
		defaultMessage: 'Notifications',
		description: 'title for Notifications navigation item for next gen notifications nested nav',
	},
	itemBack: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.item-back',
		defaultMessage: 'Back to project',
		description: 'Navigation item which brings the navigation back to project home',
	},
	goToSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.go-to-settings',
		defaultMessage: 'Back to settings',
		description:
			'Navigation item which brings the navigation back to settings from any subnav nest',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.title',
		defaultMessage: 'Project settings',
		description: 'Title for project settings navigation panel',
	},
	fieldsNonFinal: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.fields-non-final',
		defaultMessage: 'Fields',
		description: 'title for Fields navigation item',
	},
	issueTypes: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types',
		defaultMessage: 'Request types',
		description: 'title for Request types navigation item',
	},
	incidentManagement: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.incident-management',
		defaultMessage: 'Incident management',
		description: 'title for Incident management navigation item',
	},
	channels: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.channels',
		defaultMessage: 'Channels',
		description: 'title for the channels navigation item',
	},
	languageSupport: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.language-support',
		defaultMessage: 'Language support',
		description: 'Language Support Settings navigation menu link for a service project',
	},
	knowledgeBase: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'title for Knowledge base navigation item',
	},
	automation: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.automation',
		defaultMessage: 'Automation',
		description: 'Settings navigation menu link for a service project',
	},
	playbooks: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.playbooks',

		defaultMessage: 'Playbooks',
		description: 'Settings navigation menu link for a service project',
	},
	slaSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.sla-settings',
		defaultMessage: 'SLAs',
		description: 'title for SLAs settings navigation item',
	},
	customerSatisfaction: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.customer-satisfaction',
		defaultMessage: 'Customer satisfaction',
		description: 'Customer satisfaction Settings navigation menu link for a service project',
	},
	ejectToClassic: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.eject-to-classic',
		defaultMessage: 'Advanced',
		description: 'Title for eject to classic navigation item',
	},
	chat: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.chat',
		defaultMessage: 'Chat',
		description: 'title for the Chat settings navigation item',
	},
	forms: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.forms',
		defaultMessage: 'Forms',
		description: 'Title for the Forms settings navigation item',
	},
	newLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the nav item, indicating a new feature.',
	},
	externalLinks: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.external-links',
		defaultMessage: 'External resources',
		description: 'Nav item label for configuring external resources of a servicedesk project',
	},
	dataClassificationsNonFinal: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.data-classifications-non-final',
		defaultMessage: 'Data classifications',
		description:
			'Nav item label for configuring data classifications for the current project of a servicedesk project',
	},
	accessGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.access-group',
		defaultMessage: 'Access',
		description: 'Nav group label for access related pages',
	},
	requestsManagementGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.requests-management-group',
		defaultMessage: 'Request management',
		description: 'Nav group label for request management related pages',
	},
	channelsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.channels-group',
		defaultMessage: 'Channels & self service',
		description: 'Nav group label for channels related pages',
	},
	notificationsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.notifications-group',
		defaultMessage: 'Notifications',
		description: 'Nav group label for notifications related pages',
	},
	integrationsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.integrations-group',
		defaultMessage: 'Apps',
		description: 'Nav group label for integrations related pages',
	},
	journeysNonFinal: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.journeys-non-final',
		defaultMessage: 'Journeys',
		description:
			'Settings navigation menu link text for a JSM project, to navigate to the Journeys page. A journey is an overarching, end-to-end process that connects activities together. e.g. Employee onboarding',
	},
});
